import { motion } from "framer-motion";
import Navigation from "../../components/Navigation";
import PageHero from "../../components/PageHero";

// Mission and Vision Page
const MissionVisionPage = () => {
  return (
    <div data-testid="mission-vision-page" className="min-h-screen bg-[#FAFAFA]">
      <Navigation />
      
      <PageHero 
        image="https://customer-assets.emergentagent.com/job_7b46b431-509a-4162-84d5-ce52c765da4c/artifacts/jdsbq9yo_Phyllis.jpg"
        alt="Mission and Vision"
      />

      {/* Mission and Vision Content */}
      <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="space-y-10">
              {/* Mission */}
              <div>
                <h2 
                  className="text-2xl md:text-3xl font-bold text-[#1A1A1A] mb-4"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  Our Mission
                </h2>
                <p className="text-[#666666] text-base md:text-lg leading-relaxed">
                  Murphy's Giving Market is a largely volunteer organization that primarily serves people in poverty in Upper Darby and surrounding areas. We provide fresh, healthful, and culturally appropriate food options, clothing, and hygiene products; facilitate access to a wide network of resources; and empower clients to create long-lasting changes in their lives and communities.
                </p>
              </div>

              {/* Vision */}
              <div>
                <h2 
                  className="text-2xl md:text-3xl font-bold text-[#1A1A1A] mb-4"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  Our Vision
                </h2>
                <p className="text-[#666666] text-base md:text-lg leading-relaxed">
                  Murphy's Giving Market envisions a healthy, collaborative, and thriving community.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default MissionVisionPage;
